export const environmentCommon = {
	demo: false,
	version: '0.6.0'
};
